import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=50454bb4&scoped=true"
import script from "./FormModal.vue?vue&type=script&lang=js"
export * from "./FormModal.vue?vue&type=script&lang=js"
import style0 from "./FormModal.vue?vue&type=style&index=0&id=50454bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50454bb4",
  null
  
)

export default component.exports